export const DefaultDesktopMinZoom = 5
export const DefaultDesktopMaxZoom = 18
export const DefaultMobileMinZoom = 5
export const DefaultMobileMaxZoom = 18
